(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const slides = [...root.querySelectorAll('[data-carousel-slide]')];
    if (!slides.length) return;
    const track = root.querySelector('[data-carousel-track]');
    const dots = [...root.querySelectorAll('[data-carousel-dot]')];
    const pause = root.querySelector('[data-carousel-pause]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = matchMedia('(max-width: 749px)');
    let current = 0, timer, paused = reduced.matches, hovered = false, focused = false, start;
    const videos = [...root.querySelectorAll('video')];
    function media() {
      videos.forEach(video => {
        const source = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        if (video.getAttribute('src') !== source) { video.src = source; video.load(); }
        if (slides[current].contains(video) && !paused && !document.hidden) video.play().catch(() => {});
        else video.pause();
      });
    }
    function schedule() {
      clearTimeout(timer);
      if (root.dataset.autoplay === 'true' && slides.length > 1 && !paused && !hovered && !focused && !document.hidden)
        timer = setTimeout(() => show(current + 1), 9000);
    }
    function show(index, announce = false) {
      current = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${current * 100}%)`;
      slides.forEach((slide, i) => { slide.inert = i !== current; slide.setAttribute('aria-hidden', String(i !== current)); });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
      if (announce) root.querySelector('[data-carousel-status]').textContent = `Campaign ${current + 1} of ${slides.length}`;
      media(); schedule();
    }
    root.querySelector('[data-carousel-next]')?.addEventListener('click', () => show(current + 1, true));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i, true)));
    pause?.addEventListener('click', () => {
      paused = !paused;
      pause.textContent = paused ? '▶' : 'Ⅱ';
      pause.setAttribute('aria-label', paused ? 'Play animation' : 'Pause animation');
      media(); schedule();
    });
    root.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); show(current + (e.key === 'ArrowRight' ? 1 : -1), true); }
    });
    root.addEventListener('pointerenter', e => { if (e.pointerType !== 'touch') { hovered = true; schedule(); } });
    root.addEventListener('pointerleave', () => { hovered = false; schedule(); });
    root.addEventListener('focusin', () => { focused = true; schedule(); });
    root.addEventListener('focusout', e => { focused = root.contains(e.relatedTarget); schedule(); });
    root.addEventListener('touchstart', e => { start = {x:e.touches[0].clientX,y:e.touches[0].clientY}; }, {passive:true});
    root.addEventListener('touchend', e => {
      if (!start) return;
      const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;
      if (Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)*1.4) show(current + (dx<0 ? 1 : -1), true);
      start = null;
    }, {passive:true});
    mobile.addEventListener('change', media);
    document.addEventListener('visibilitychange', () => { media(); schedule(); });
    document.addEventListener('shopify:block:select', e => {
      const i = slides.findIndex(slide => slide.dataset.blockId === e.detail?.blockId);
      if (i !== -1) { paused = true; show(i); }
    });
    document.addEventListener('shopify:section:unload', e => { if (e.target.contains(root)) { clearTimeout(timer); videos.forEach(video=>video.pause()); } });
    show(0);
    if (paused) { pause.textContent='▶'; pause.setAttribute('aria-label','Play animation'); }
  }
  document.querySelectorAll('[data-to-carousel]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-to-carousel]').forEach(init));
})();
